import { styled } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const Badge = styled("div")(({ theme }) => ({
  position: "absolute",
  bottom: 8,
  right: 8,
  minWidth: 36,
  height: 36,
  borderRadius: 18,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0 8px",
  backgroundColor: theme.palette.error.main,
  color: "#fff",
  fontWeight: 600,
  fontSize: "0.875rem",
  zIndex: 1,
}));

const RecordingTimer = ({ display, isFlashing }) => (
  <Badge
    role="timer"
    aria-live="polite"
    style={
      isFlashing
        ? { animation: "recording-timer-flash 2s infinite" }
        : undefined
    }
  >
    <style>{`
      @keyframes recording-timer-flash {
        0% { opacity: 1; }
        50% { opacity: 0.4; }
        100% { opacity: 1; }
      }
    `}</style>
    {display}
  </Badge>
);

RecordingTimer.propTypes = {
  display: PropTypes.string.isRequired,
  isFlashing: PropTypes.bool,
};

export default RecordingTimer;
